//预置邮箱号码弹框组件
<template>
  <div
    class="account-wrapper"
    :style="showModal?'display:block':'display:none'"
  >
    <div class="m-mask confirm-ant-show-mask"></div>
    <div class="account-content">
      <div class="account-title">
        <div>请选择您要登录的账号</div>
        <i
          class="i-icon i-icon-close"
          @click="closeModal"
        ></i>
      </div>
      <div class="account-info">
        <div
          v-for="item in account"
          @click="chooseAccount(item)"
        >
          {{item}}
        </div>
        <div
          class="account-another"
          @click="closeModal"
        >
          使用其他账号
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "preAccount",
  props: {
    account: Array
  },
  data() {
    return {
      showModal: true
    };
  },
  methods: {
    closeModal ($event) {
      this.showModal = false
      this.$emit('closeModal', $event)
    },
    chooseAccount (item) {
      this.showModal = false
      this.$emit('choose', item)
    }
  }
};
</script>
<style lang="scss">
.account-wrapper {
  /* 遮罩弹窗 */
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 101;
  .m-mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 991;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .account-content {
    width: 75%;
    top: 25%;
    position: relative;
    background: #fff;
    z-index: 1000;
    margin: 0 auto;
    border-radius: 4px;
  }
  .account-title {
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-weight: 600;
    // border-bottom:1px solid #d0d0d0;
    .i-icon-close {
      position: absolute;
      right: 8px;
      top: 10px;
    }
  }
  .account-info {
    div {
      height: 44px;
      line-height: 44px;
      border-top: 1px solid #d0d0d0;
      padding-left: 20px;
      color: #555;
    }
  }
 @media screen and (orientation: landscape) {
  /*横屏 css*/
  .account-content{
     max-height:60%;
     overflow-y: auto;
  }
}
}
</style>



// WEBPACK FOOTER //
// preAccount.vue?98ac41cc